import { useContext } from 'react';
import { createStableContext } from '../app/stable-context.ts';

/**
 * Inside a dashboard card of a set size (pages/DashboardBoard.tsx): its content fills the card and
 * adapts to it — a chart takes the height left, a long list scrolls — instead of setting the height.
 */
export const TileContext = createStableContext<boolean>('tile', false);

export function useInTile(): boolean {
  return useContext(TileContext);
}
